<template>
  <div :style="divStyle">
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Tabs>
      <TabPane label="列表结构" name="list" icon="ios-list">
        <Row style="padding-bottom: 10px;margin-top: 10px;">
          <Col span="4" style="padding-right: 10px;">
            <Button type="primary" long @click="onClickSearch">检索</Button>
          </Col>
        </Row>
        <Table
          ref="selectionTable"
          :max-height="height"
          :data="showData"
          :columns="showColumns"
          stripe
          border
        ></Table>
        <Page
          :current="currentPage"
          :total="dataCount"
          :page-size="pageSize"
          show-sizer
          show-total
          @on-change="changePage"
          @on-page-size-change="changePageSize"
          style="text-align:right"
        ></Page>
      </TabPane>
      <TabPane label="树形结构" name="tree" icon="ios-git-merge">
        <Tree :data="data5" :render="renderContent"></Tree>
      </TabPane>
    </Tabs>

    <!-- 模态框 -->
    <Modal title="Title" v-model="isModalShow" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create" />
        <span>{{modalTitle}}</span>
      </p>
      <div style="text-align:center">
        <div style="margin-bottom: 10px">
          <span>父级员工名称</span>
          <Input readonly v-model="parentNodeName" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>父级员工编号</span>
          <Input readonly v-model="parentNodeId" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前员工姓名</span>
          <Input
            v-model="currentNodeName"
            placeholder="请输入当前员工名称"
            style="margin-left:10px; width: 150px"
          />
        </div>
        <div style="margin-bottom: 10px" v-if="modalType == 'add'">
          <span>当前员工编号</span>
          <Input v-model="currentNodeId" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px" v-if="modalType == 'edit'">
          <span>当前员工编号</span>
          <Input readonly v-model="currentNodeId" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>当前员工类型</span>
          <Select
            v-model="currentNodeTypes"
            style="margin-left:10px; width:150px"
            placeholder="请选员工类型"
            multiple
            @on-change="onChangePersonnelType"
          >
            <Option v-for="(value, key) in personnelTypeEnum" :value="value" :key="key">{{value}}</Option>
          </Select>
        </div>
        <div style="margin-bottom: 10px">
          <span>员工身份证号</span>
          <Input v-model="currentNodeIdCard" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>员工联系方式</span>
          <Input v-model="currentNodePhone" style="margin-left:10px; width: 150px" />
        </div>
        <div style="margin-bottom: 10px">
          <span>员工管辖机构</span>
          <Select
            v-model="currentNodeGoverning"
            style="margin-left:10px; width:150px"
            placeholder="请选员工管辖机构"
          >
            <Option
              v-for="value in governingBodyList"
              :value="value.governingBodyId"
              :key="value.governingBodyId"
            >{{value.governingBodyName}}</Option>
          </Select>
        </div>
        <div style="margin-bottom: 10px">
          <span>当前员工备注</span>
          <Input v-model="currentNodeRemark" style="margin-left:10px; width: 150px" />
        </div>
      </div>
      <div slot="footer">
        <Button
          :loading="isLoading"
          icon="md-search"
          type="info"
          size="large"
          long
          @click="modalButtonClick"
        >{{modalButtonName}}</Button>
      </div>
    </Modal>
    <!-- 修改密码 -->
    <Modal title="Title" v-model="isPasswordModalShow" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create" />
        <span>修改密码</span>
      </p>
      <div style="text-align:center">
        <div style="margin-bottom: 10px">
          <span>新密码</span>
          <Input v-model="newPassword" style="margin-left:10px; width: 150px" />
        </div>
      </div>
      <div slot="footer">
        <Button
          :loading="isLoading"
          icon="md-search"
          type="info"
          size="large"
          long
          @click="modalPasswordButtonClick"
        >提交修改</Button>
      </div>
    </Modal>
    <!-- 模态框 -->
    <Modal v-model="isShowModalSearch" :mask-closable="false" width="380">
      <p slot="header" style="color:#2d8cf0;text-align:center">
        <Icon type="md-create" />
        <span>按照输入的字段检索员工</span>
      </p>
      <Form ref="searchParam" :label-width="100" :model="searchParam">
        <FormItem prop="personnelSeriesNumber" label="员工编号：">
          <Input v-model="searchParam.personnelSeriesNumber" clearable placeholder="请输入员工编号..."></Input>
        </FormItem>
        <FormItem prop="personnelName" label="员工姓名：">
          <Input v-model="searchParam.personnelName" clearable placeholder="请输入员工姓名..."></Input>
        </FormItem>
        <FormItem prop="personnelIdcard" label="员工身份证：">
          <Input v-model="searchParam.personnelIdcard" clearable placeholder="请输入员工身份证..."></Input>
        </FormItem>
        <FormItem prop="personnelPhone" label="手机号：">
          <Input v-model="searchParam.personnelPhone" clearable placeholder="请输入手机号..."></Input>
        </FormItem>
        <FormItem prop="personnelType" label="人员类型：">
          <Select v-model="searchParam.personnelType" placeholder="请选人员类型">
            <Option v-for="(value, key) in personnelTypeEnum" :value="value" :key="key">{{value}}</Option>
          </Select>
        </FormItem>
        <FormItem prop="governingBodyName" label="管辖机构：">
          <Select v-model="searchParam.governingBodyName" placeholder="请选员工管辖机构">
            <Option
              v-for="value in governingBodyList"
              :value="value.governingBodyName"
              :key="value.governingBodyId"
            >{{value.governingBodyName}}</Option>
          </Select>
        </FormItem>、
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" long @click="commitSearch">检索</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "personnel_body_menu",
  computed: {
    divStyle() {
      var style = {};
      if (this.$parent.$refs.mainContent) {
        style.width = this.$parent.$refs.mainContent.clientWidth - 54 + "px";
      } else {
        style.width = window.innerWidth - 279 + "px";
      }
      //style.height = (this.$parent.$refs.mainContent.clientHeight - 54) + 'px';
      return style;
    }
  },
  created() {
    this.request();
  },
  mounted() {
    this.showPage();
  },
  data() {
    return {
      isLoading: false,
      height: window.innerHeight,
      isSpinShow: false,
      currentPage: 1,
      dataCount: 0,
      pageSize: 10,
      showData: [],
      showColumns: [
        {
          title: "员工编号",
          key: "personnelSeriesNumber",
          tooltip: true
        },
        {
          title: "员工姓名",
          key: "personnelName"
        },
        {
          title: "员工身份证",
          key: "personnelIdcard"
        },
        {
          title: "手机号",
          key: "personnelPhone"
        },
        {
          title: "人员类型",
          key: "personnelType",
          tooltip: true
        },
        {
          title: "管辖机构",
          key: "governingBodyName"
        }
      ],
      data5: [],
      governingBodyList: [],
      isModalShow: false,
      isPasswordModalShow: false,
      currentPasswordModel: {},
      newPassword: "",
      modalButtonName: "新增",
      modalTitle: "新增员工",
      modalType: "add",
      parentNodeName: "",
      parentNodeId: 0,
      currentNodeName: "",
      currentNodeId: 0,
      currentNodeType: "",
      currentNodeTypes: [],
      currentNodeGoverning: "",
      currentNodeIdCard: "",
      currentNodePhone: "",
      currentNodeLevel: "",
      currentNodeRemark: "",
      personnelTypeEnum: global.personnelType,
      buttonProps: {
        type: "default",
        size: "small"
      },
      isShowModalSearch: false,
      searchParam: {}
    };
  },
  methods: {
    showPage() {
      let that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/personnel/selectPage?page=" +
          that.currentPage +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify(that.searchParam),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.showData = data.body.resultList;
          that.dataCount = data.body.amount;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
    },
    changePage(index) {
      this.currentPage = index;
      this.showPage();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.showPage();
    },
    request() {
      this.isSpinShow = true;
      var that = this;
      $.ajax({
        url: "/api/getPersonnelTree",
        contentType: "application/json",
        type: "get",
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          that.$Notice.success({
            title: "提示",
            desc: "载入员工信息成功"
          });
          data.body[0]["render"] = (h, { root, node, data }) => {
            return (
              "span",
              { style: { display: "inline-block", width: "100%" } },
              [
                h("span", [
                  h("Icon", {
                    props: { type: "ios-folder-outline" },
                    style: { marginRight: "8px" }
                  }),
                  h("span", data.title)
                ]),
                h(
                  "span",
                  {
                    style: {
                      display: "inline-block",
                      marginLeft: "32px",
                      marginRight: "32px"
                    }
                  },
                  [
                    h("Button", {
                      props: Object.assign({}, that.buttonProps, {
                        icon: "ios-add",
                        type: "primary"
                      }),
                      style: { width: "64px" },
                      on: {
                        click: () => {
                          if (localStorage.getItem("isAdmin") == "false") {
                            that.isModalShow = false;
                            that.$Notice.info({
                              title: "提示",
                              desc: "您的权限不足！"
                            });
                            return;
                          } else {
                            that.append(root, node, data);
                          }
                        }
                      }
                    })
                  ]
                )
              ]
            );
          };
          that.data5 = data.body;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function() {
          that.isSpinShow = false;
        }
      });
      $.ajax({
        url: "/api/info/governingBodyList",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({}),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }
          console.log(data.body);
          that.governingBodyList = data.body;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    },
    renderContent(h, { root, node, data }) {
      return h(
        "span",
        {
          style: {
            display: "inline-block",
            width: "100%"
          }
        },
        [
          h("span", [
            h("Icon", {
              props: {
                type: "ios-paper-outline"
              },
              style: {
                marginRight: "8px"
              }
            }),
            h("span", data.title)
          ]),
          h(
            "span",
            {
              style: {
                display: "inline-block",
                marginLeft: "32px",
                marginRight: "32px"
              }
            },
            [
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-add"
                }),
                style: {
                  marginRight: "8px"
                },
                on: {
                  click: () => {
                    this.append(root, node, data);
                  }
                }
              }),
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-remove"
                }),
                style: {
                  marginRight: "8px"
                },
                on: {
                  click: () => {
                    this.remove(root, node, data);
                  }
                }
              }),
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-create-outline"
                }),
                style: {
                  marginRight: "8px"
                },
                on: {
                  click: () => {
                    this.edit(root, node, data);
                  }
                }
              }),
              h("Button", {
                props: Object.assign({}, this.buttonProps, {
                  icon: "ios-key-outline"
                }),
                on: {
                  click: () => {
                    this.updatePassword(root, node, data);
                  }
                }
              })
            ]
          )
        ]
      );
    },
    append(root, node, data) {
      (this.modalButtonName = "新增"),
        (this.modalTitle = "新增员工"),
        (this.modalType = "add"),
        (this.parentNodeName = node.node.title);
      this.currentNodeName = "";
      if (node.node.id == 0) {
        this.currentNodeLevel = 0;
      } else {
        this.currentNodeLevel = node.node.level * 1; // *1=>字符转数字
      }
      this.currentNodeId = "";
      this.currentNodeTypes = [];
      this.currentNodeGoverning = "";
      this.currentNodeIdCard = "";
      this.currentNodePhone = "";
      this.currentNodeRemark = "";
      this.parentNodeId = data.id;
      this.isModalShow = true;
      const children = data.children || [];
      this.$set(data, "expand", true);
      this.$set(data, "children", children);
      this.isModalShow = true;
    },
    remove(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      const index = parent.children.indexOf(data);
      this.delPersonnel(data.id);
    },
    edit(root, node, data) {
      const parentKey = root.find(el => el === node).parent;
      const parent = root.find(el => el.nodeKey === parentKey).node;
      (this.modalButtonName = "修改"),
        (this.modalTitle = "修改员工"),
        (this.modalType = "edit"),
        (this.parentNodeName = parent.title);
      this.parentNodeId = data.pid;
      this.currentNodeName = data.title;
      this.currentNodeTypes = data.type.split(",");
      this.currentNodeId = data.id;
      this.currentNodeType = data.type;
      this.currentNodeGoverning = data.goveringBodyId;
      this.currentNodeIdCard = data.idCard;
      this.currentNodePhone = data.phone;
      this.currentNodeRemark = data.remark;
      this.currentNodeLevel = data.level;
      this.isModalShow = true;
    },
    updatePassword(root, node, data) {
      console.log(data);
      this.currentPasswordModel = data;
      this.isPasswordModalShow = true;
    },
    delPersonnel(id) {
      this.$Modal.confirm({
        title: "确认",
        content: "<p>确认删除当前节点及子节点信息？</p>",
        onOk: () => {
          var that = this;
          that.isSpinShow = true;
          $.ajax({
            url: "/api/delPersonnel",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify({
              id: id
            }),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
              that.request();
              that.$Notice.success({
                title: "提示",
                desc: "员工基础信息删除成功"
              });
            },
            error: function(textStatus) {
              that.loading = false;
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function(XMLHttpRequest, textStatus) {
              that.isSpinShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    },
    commitVerification() {
      if (!this.currentNodeName) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入员工姓名！"
        });
        return false;
      }
      if (!this.currentNodeId) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入员工编号！"
        });
        return false;
      }
      if (!this.currentNodeType) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入员工类型！"
        });
        return false;
      }
      let currentNodeIdCardr = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/;
      let currentNodeIdCardflag = currentNodeIdCardr.test(
        this.currentNodeIdCard
      );
      if (!currentNodeIdCardflag) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入正确的身份证号！"
        });
        return false;
      }
      let currentNodePhoner = /^1[3|4|5|7|8][0-9]{9}$/;
      let currentNodePhoneflag = currentNodePhoner.test(this.currentNodePhone);
      if (!currentNodePhoneflag) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入正确的联系方式！"
        });
        return false;
      }
      if (!this.currentNodeGoverning) {
        this.$Notice.warning({
          title: "异常",
          desc: "请输入员工管辖机构！"
        });
        return false;
      }
      return true;
    },
    modalPasswordButtonClick() {
      let that = this;
      this.$Modal.confirm({
        title: "确认",
        content: "<p>确认修改密码？</p>",
        onOk: () => {
          that.isSpinShow = true;
          let paramObj = {};
          paramObj.userAccount = this.currentPasswordModel.id;
          paramObj.uesrPassword = this.newPassword;
          $.ajax({
            url: "/api/updatePassword",
            contentType: "application/json",
            type: "post",
            data: JSON.stringify(paramObj),
            dataType: "json",
            success: function(data) {
              if (data.errorCode != 0) {
                that.$Notice.error({
                  title: "异常",
                  desc: data.errorInfo
                });
                return;
              }
            },
            error: function(textStatus) {
              that.$Notice.error({
                title: "异常",
                desc: "接口请求异常"
              });
            },
            complete: function() {
              that.isSpinShow = false;
              that.isPasswordModalShow = false;
            }
          });
        },
        onCancel: () => {}
      });
    },
    modalButtonClick() {
      if (this.commitVerification()) {
        var that = this;
        that.isSpinShow = true;
        that.isLoading = true;
        that.isModalShow = false;
        $.ajax({
          url: "/api/updatePersonnel",
          contentType: "application/json",
          type: "post",
          data: JSON.stringify({
            updateType: this.modalType,
            pid: this.parentNodeId,
            name: this.currentNodeName,
            type: this.currentNodeType,
            id: this.currentNodeId,
            governing: this.currentNodeGoverning,
            idCard: this.currentNodeIdCard,
            phone: this.currentNodePhone,
            level: this.currentNodeLevel,
            remark: this.currentNodeRemark
          }),
          dataType: "json",
          success: function(data) {
            console.log(data);
            if (data.errorCode != 0) {
              that.$Notice.error({
                title: "异常",
                desc: data.errorInfo
              });
              return;
            }

            that.request();
            that.isModalShow = false;
            that.$Notice.success({
              title: "提示",
              desc: "员工基础信息升级成功"
            });
          },
          error: function(textStatus) {
            that.loading = false;
            that.$Notice.error({
              title: "异常",
              desc: "接口请求异常"
            });
          },
          complete: function(XMLHttpRequest, textStatus) {
            that.isSpinShow = false;
            that.isLoading = false;
            that.currentNodeId = "";
            that.currentNodeType = "";
            that.currentNodeName = "";
            that.currentNodeIdCard = "";
            that.currentNodePhone = "";
            that.currentNodeGoverning = "";
            that.currentNodeRemark = "";
          }
        });
      } else {
      }
    },
    onChangePersonnelType() {
      this.currentNodeType = this.currentNodeTypes.join(",");
    },
    onClickSearch() {
      this.isShowModalSearch = true;
    },
    commitSearch() {
      console.log(this.searchParam);
      this.isShowModalSearch = false;
      this.showPage();
    }
  }
};
</script>
<style>
.ivu-tree {
  left: 30%;
}
.ivu-tree ul {
  /* list-style: none; */
  margin: 5px;
  padding: 0;
  font-size: 16px;
}
</style>
